<template>
    <div class="other_view_main">
        <div class="other_top"></div>
        <div class="other_bottom">
            <div class="bottom_left_info">
                <div class="left_menu">
                    <div class="menu_logo">新闻中心</div>
                    <div class="menu_list">
                        <div class="menu_item" v-for="(item, i) in leftMenuList" :key="i" @click="selectMenuI = i"
                            :style="{
                                background: selectMenuI === i ? '#619533' : '#eee',
                                color: selectMenuI === i ? '#fff' : '#000',
                            }">
                            <div class="menu_item_icon" :style="{ color: selectMenuI === i ? '#fff' : '#619533', }"><i
                                    class="el-icon-caret-right"></i></div>
                            {{ item.name }}
                        </div>
                    </div>
                    <div class="menu_footer">
                        <div class="footer_logo"></div>
                        <div class="footer_text1">
                            {{ infoJson.companyInfo.name }}
                        </div>
                        <div class="footer_text2">
                            地址：{{ infoJson.companyInfo.address }}
                        </div>
                        <div class="footer_text2">
                            电话：{{ infoJson.companyInfo.phone }}
                        </div>
                        <div class="footer_text2">
                            传真：{{ infoJson.companyInfo.fax }}
                        </div>
                        <div class="footer_text2">
                            邮箱：{{ infoJson.companyInfo.email }}
                        </div>
                        <div class="footer_text3">
                            “守合同重信用”企业
                        </div>
                        <div class="footer_text4">
                            亘利建筑咨询电话：
                        </div>
                        <div class="footer_text5">
                            {{ infoJson.companyInfo.phone }}
                        </div>
                    </div>
                </div>
                <div class="right_info"></div>
            </div>
            <div class="bottom_right_content">
                <div class="right_top_title">
                    {{ leftMenuList[selectMenuI].name }}
                    <div class="right_bottom_hen"></div>
                </div>
                <div class="right_bottom_content">
                    <template v-if="selectMenuI == 0">
                        <div class="company_news_list">
                            <div class="news_item" v-for="(item, i) in infoJson.companyNews" :key="i"
                                @click="handleNews(item)">
                                <div class="news_title">>> {{ item.title }}</div>
                                <div class="news_desc">[{{ item.date }}]</div>
                            </div>
                        </div>
                    </template>
                    <template v-if="selectMenuI == 1">
                        <div class="company_news_list">
                            <div class="news_item" v-for="(item, i) in infoJson.industryNews" :key="i"
                                @click="handleNews(item)">
                                <div class="news_title">>> {{ item.title }}</div>
                                <div class="news_desc">[{{ item.date }}]</div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <el-dialog :title="newsItem.title" :visible.sync="dialogVisible" width="50%">
            <div class="modal_date">[{{ newsItem.date }}]</div>
            <div class="modal_content">{{ newsItem.content }}</div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import infoJson from "@/utils/info.json";
export default {
    components: {},
    data() {
        return {
            dialogVisible: false,
            newsItem: { title: "", date: "", content: "" },
            infoJson,
            selectMenuI: 0,
            leftMenuList: [
                { name: "公司动态", url: "" },
                { name: "行业资讯", url: "" },
            ],
        };
    },
    methods: {
        handleNews(item) {
            this.newsItem = item;
            this.dialogVisible = true;
        },
        requireImg(img) {
            return require(`@/assets${img.url}`);
        },
    }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__body {
    padding: 0 20px;
}


.modal_date {
    margin-bottom: 10px;
}

.modal_content {
    text-indent: 2em;
}

.other_view_main {
    .other_top {
        background-image: url(@/assets/other/other_bg.jpg);
        width: 100%;
        height: 380px;
    }

    .other_bottom {
        padding: 20px 15%;
        width: 70%;
        min-height: 400px;
        display: flex;
        background: #eee;

        .bottom_left_info {
            background: #fff;
            width: 281px;
            padding: 20px;
            min-height: 300px;

            .left_menu {
                width: 100%;

                .menu_footer {
                    margin-top: 40px;
                    color: rgba(0, 0, 0, 0.8);

                    .footer_text3 {
                        text-align: center;
                        font-size: 26px;
                        margin: 10px 0;
                        color: rgba(0, 0, 0, 0.7);
                    }

                    .footer_text5 {
                        color: #ff7e00;
                        font-size: 30px;
                        font-weight: bold;
                    }

                    .footer_text4 {
                        font-weight: 400;
                        font-size: 14px;
                    }

                    .footer_text2 {

                        font-weight: 400;
                        font-size: 14px;
                    }

                    .footer_text1 {
                        margin-bottom: 10px;
                        font-weight: 500;
                        font-size: 18px;
                    }

                    .footer_logo {
                        background-image: url(@/assets/other/contact_logo.jpg);
                        width: 201px;
                        height: 106px;
                        line-height: 90px;
                        font-size: 24px;
                        color: #fff;
                        font-weight: 600;
                        padding-left: 40px;
                    }
                }

                .menu_list {
                    .menu_item {
                        height: 50px;
                        width: 241px;
                        background: #eee;
                        text-align: center;
                        line-height: 50px;
                        margin-top: 1px;
                        cursor: pointer;
                        font-size: 16px;
                        position: relative;

                        .menu_item_icon {
                            color: #619533;
                            position: absolute;
                            left: 30px;
                            top: 50%;
                            transform: translateY(-50%);
                        }
                    }
                }

                .menu_logo {
                    background-image: url(@/assets/other/other_logo.png);
                    width: 201px;
                    height: 106px;
                    line-height: 90px;
                    font-size: 24px;
                    color: #fff;
                    font-weight: 600;
                    padding-left: 40px;
                }
            }
        }

        .bottom_right_content {
            background: #fff;
            width: calc(100% - 281px);
            padding: 20px;
            min-height: 300px;

            .right_bottom_content {

                .company_news_list {
                    .news_item {
                        display: flex;
                        height: 40px;
                        line-height: 40px;
                        border-bottom: 1px dashed #619533;

                        .news_title {
                            font-size: 16px;
                        }

                        .news_desc {
                            color: rgba(0, 0, 0, 0.6);
                            margin-left: auto;
                            font-size: 14px;
                            color: rgba(0, 0, 0, 0.5);
                        }

                        cursor: pointer;

                        &:hover {
                            .news_title {
                                color: #619533;
                            }
                        }
                    }
                }

                margin-top: 20px;
                line-height: 30px;

                .content_desc {
                    text-indent: 2em;
                }

                .qualification_list {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 20px;
                    width: 100%;

                    .qualification_item {
                        width: calc(100% / 3 - 20px);
                        text-align: center;
                        cursor: pointer;

                        .qualification_name {
                            margin-top: 10px;
                            font-size: 12px;
                            color: rgba(0, 0, 0, 0.8);
                            font-weight: 500;
                            text-align: center;
                        }

                        img {
                            height: 150px;
                        }

                        &:hover {
                            .qualification_name {
                                color: #619533;
                            }
                        }
                    }
                }
            }

            .right_top_title {
                height: 40px;
                border-bottom: 2px solid #eee;
                color: #619533;
                font-size: 18px;
                font-weight: bold;
                text-align: left;
                padding-left: 15px;
                position: relative;

                .right_bottom_hen {
                    height: 2px;
                    border-bottom: 2px solid #619533;
                    font-size: 18px;
                    width: 120px;
                    left: 0;
                    bottom: -2px;
                    position: absolute;
                    z-index: 999;
                }
            }
        }
    }


}
</style>